import { Box } from "@mui/material";
import Router from "./routes/Router";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18n from "./utils/i18n";

function App() {
  const location = useLocation();
  
  useEffect(() => {
    // Try to extract language from URL
    const pathParts = location.pathname.split('/').filter(part => part);
    if (pathParts.length > 0 && ['en', 'fr', 'es'].includes(pathParts[0])) {
      i18n.changeLanguage(pathParts[0]);
    }
  }, [location.pathname]);
  
  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
        }}
      >
        <Router />
      </Box>
    </>
  );
}

export default App;
